import '@fontsource/inter/400.css'
import '@fontsource/inter/500.css'
import '@fontsource/inter/600.css'
import '@fontsource/inter/700.css'
import '@fontsource/inter/800.css'
import '@fontsource/inter/900.css'
import { createRoot } from 'react-dom/client'
import App from './App.tsx'
import './index.css'

import * as Sentry from '@sentry/react'

Sentry.init({
  dsn: 'https://49e62bd9746dc529f9f57bd6a5132a35@o370725.ingest.us.sentry.io/4509984095404032',
  // Setting this option to true will send default PII data to Sentry.
  // For example, automatic IP address collection on events
  sendDefaultPii: true,
  environment: import.meta.env.VITE_MYDRA_ENV ?? 'local',
})

createRoot(document.getElementById('root')!).render(<App />)
